import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  Box,
  Container,
  Heading,
  Text,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Image,
  Spinner,
  Flex,
  TableContainer,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalCloseButton,
} from "@chakra-ui/react";
import axios from "axios";
import * as mod from "../../url";
import Navbar from "../Navbar/Navbar";
import Sidebar from "../Sidebar";

const SIDEBAR_WIDTH = "250px";

const SingleMootUser = () => {
  const { id } = useParams();
  const [userData, setUserData] = useState(null);
  const storedData = JSON.parse(sessionStorage.getItem("superAdminLawvs"));
  const token = storedData?.data?.token;
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedImage, setSelectedImage] = useState(null);

  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
    onOpen();
  };

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const config = { headers: { Authorization: `${token}` } };
        const { data } = await axios.get(
          `${mod.api_url}/api/v1/MootUser/get_mootuser_profile/${id}`,
          config
        );
        setUserData(data.user);
      } catch (error) {
        console.error("Failed to fetch user", error);
      }
    };

    fetchUser();
  }, [id]);

  if (!userData) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" h="100vh">
        <Spinner size="xl" />
      </Box>
    );
  }
  // console.log(userData, "jnjdck");
  const { email, mobile, institution, MootCourtId, createdAt, teamMembers } =
    userData;

  return (
    <>
      <Navbar />
      <Sidebar />
      <Box
        mt={{ base: "70px", md: "100px" }}
        ml={{ base: 0, md: SIDEBAR_WIDTH }}
        p={{ base: 4, md: 6 }}
      >
        <Container maxW="container.xl" py={6}>
          <Heading
            mb={4}
            bg="#D29B3F"
            p={5}
            borderRadius="md"
            fontSize={{ base: "lg", md: "2xl" }}
          >
            Moot Team Details
          </Heading>

          {/* User Details Table */}
          <Box
            w="100%"
            mb={8}
            borderRadius="md"
            overflowX="auto"
            boxShadow="md"
            p={4}
            bg="white"
          >
            <TableContainer>
              <Table variant="simple" size="sm">
                <Tbody>
                  <Tr bg="gray.100">
                    <Td fontWeight="bold" pr="50px" minW="150px" p={4}>
                      MootCourt ID:
                    </Td>
                    <Td>{MootCourtId}</Td>
                  </Tr>
                  <Tr>
                    <Td fontWeight="bold" pr="50px" p={4}>
                      Email:
                    </Td>
                    <Td>{email}</Td>
                  </Tr>
                  <Tr bg="gray.100">
                    <Td fontWeight="bold" pr="50px" p={4}>
                      Mobile:
                    </Td>
                    <Td>{mobile}</Td>
                  </Tr>
                  <Tr>
                    <Td fontWeight="bold" pr="50px" p={4}>
                      Institution:
                    </Td>
                    <Td>{institution}</Td>
                  </Tr>
                  <Tr bg="gray.100">
                    <Td fontWeight="bold" pr="50px" p={4}>
                      Register Date:
                    </Td>
                    <Td>{new Date(createdAt).toLocaleDateString()}</Td>
                  </Tr>
                </Tbody>
              </Table>
            </TableContainer>
          </Box>

          {/* Team Members Table */}
          <Heading size="md" mb={2} bg="#D29B3F" padding={4}>
            Team Members
          </Heading>
          <Box overflowX="auto" borderRadius="md" boxShadow="md" bg="white">
            <TableContainer>
              <Table variant="striped" colorScheme="gray" size="sm">
                <Thead bg="blue.100" p={5}>
                  <Tr p={5}>
                    <Th minW="80px" p={5} fontSize="l">
                      Role
                    </Th>
                    <Th minW="120px" fontSize="l">
                      Name
                    </Th>
                    <Th minW="100px" fontSize="l">
                      Gender
                    </Th>
                    <Th minW="150px" fontSize="l">
                      University
                    </Th>
                    <Th minW="120px" fontSize="l">
                      Course
                    </Th>
                    <Th minW="80px" fontSize="l">
                      Year
                    </Th>
                    <Th minW="120px" fontSize="l">
                      Contact
                    </Th>
                    <Th minW="100px" fontSize="l">
                      College ID
                    </Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {teamMembers?.map((member, index) => (
                    <Tr key={index}>
                      <Td fontSize="xl" fontWeight="600">
                        {member?.role}
                      </Td>
                      <Td>{member?.name}</Td>
                      <Td>{member?.gender}</Td>
                      <Td>{member?.university}</Td>
                      <Td>{member?.course}</Td>
                      <Td>{member?.year}</Td>
                      <Td>{member?.contact}</Td>
                      <Td>
                        {member?.collegeId ? (
                          <Image
                            src={member?.collegeId}
                            alt="College ID"
                            boxSize="100px"
                            objectFit="cover"
                            borderRadius="md"
                            cursor="pointer"
                            onClick={() => handleImageClick(member?.collegeId)}
                          />
                        ) : (
                          <Text fontSize="sm" color="gray.500">
                            No Image
                          </Text>
                        )}
                      </Td>
                      <Modal
                        isOpen={isOpen}
                        onClose={onClose}
                        size="xl"
                        isCentered
                      >
                        <ModalOverlay />
                        <ModalContent>
                          <ModalCloseButton color="blue" />
                          <ModalBody p={4}>
                            {selectedImage && (
                              <Image
                                src={selectedImage}
                                alt="College ID"
                                width="100%"
                                height="80vh"
                                objectFit="contain"
                                borderRadius="md"
                              />
                            )}
                          </ModalBody>
                        </ModalContent>
                      </Modal>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </TableContainer>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default SingleMootUser;
